// Manage Account request functions (the centralized service layer; FRONTEND_RULES
// §9). Pure async functions over the shared client — no Redux, no React. The slice
// thunk composes them.

import { apiGet } from './client';

/**
 * GET /manage-account?accountId= — the levers for one account (pay, contributions,
 * elections, rebalance, transfer, fund lineup).
 * @param {string} accountId e.g. "ACC-P001-ACME"
 */
export function getManageAccount(accountId) {
  return apiGet(`/manage-account?accountId=${encodeURIComponent(accountId)}`);
}

/**
 * GET /overview?userId= — landing summary + a card per plan. Used here ONLY to
 * enrich the account hero (balance/vested/status), which /manage-account doesn't
 * carry. This is the seam the multi-plan PR replaces: when it owns the selected
 * plan card, swap this call for a selector against its slice.
 * @param {string} userId e.g. "P001"
 */
export function getOverview(userId) {
  return apiGet(`/overview?userId=${encodeURIComponent(userId)}`);
}
